module.exports = __webpack_public_path__ + "static/fonts/Gotham-Light.bceda3f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Light.otf
// module id = rUe1
// module chunks = 1